/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Offer.module.scss";
import Inputs from "../../Inputs";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { connect } from "react-redux";
import { listAgencies, createOffer } from "../../../actions/offer";
import { getCurrentTicket } from "../../../actions/tickets";
import moment from "moment";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import "./Offer.module.scss";
import _, { set } from "lodash";
import DiscountInfoModal from "../../Modals/DiscountInfoModal/DiscountInfoModal";
import ModalComponent from "../../Modals/ModalComponent/ModalComponent";
import { calculateMonetary } from "../../../utils/helperFunctions";
import Swal from "sweetalert2";
import { Switch } from "@mui/material";
import {
  convertCurrency,
  formatMoney,
  getBaseCurrencyBySwitchDate,
  getCurrencySymbol,
  getDisplayCurrencyOrderBySwitchDate,
} from "../../../utils/currency";
import { API_URL } from "../../../config/settings";

const customStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    color: "#0083E5",
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px dotted pink",
    color: state.isSelected ? "white" : "black",
    backgroundColor: state.isSelected ? "#0083E5" : "white",
    padding: 10,
  }),
  control: () => ({
    width: "200px",
    height: 40,
    display: "flex",
    border: "1px solid rgb(165, 164, 164)",
    borderRadius: "7px",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";
    return { ...provided, opacity, transition };
  },
};

const customStylesHigher = {
  ...customStyles,
  control: () => ({
    width: "200px",
    display: "flex",
    height: 70,
    border: "1px solid rgb(165, 164, 164)",
    borderRadius: "7px",
  }),
};

const instalPairs = [
  {
    key: "installmentOneDate",
    labelKey: "offers:installmentNDue", n: 1,
    sumKey: "installmentOneSum",
  },
  {
    key: "installmentTwoDate",
    labelKey: "offers:installmentNDue", n: 2,
    sumKey: "installmentTwoSum",
  },
  {
    key: "installmentThreeDate",
    labelKey: "offers:installmentNDue", n: 3,
    sumKey: "installmentThreeSum",
  },
  {
    key: "installmentFourDate",
    labelKey: "offers:installmentNDue", n: 4,
    sumKey: "installmentFourSum",
  },
];

const liquidationOptions = [
  "Официален сервиз",
  "Доверен сервиз",
  "Експертна оценка",
];
const viewOptions = ["Да", "Не"];
const additionalSecurityOptions = ["Да", "Не"];
const premiumInfoOptions = [
  "Всички суми са с включен данък.",
  "Застрахователните премии са крайни, с включени отстъпки.",
  "В качеството си на 'Специален потребител', на мобилното приложение Амарант в офертата е калкулирана и допълнителна преференциална отстъпка за Вас",
  "Застрахователните премии са валидни до промяна в тарифата на застрахователя или рисковите обстоятелства",
];

const CreateOffer = ({
  listAgencies,
  agencies,
  createOffer,
  getCurrentTicket,
  currentTicket,
}) => {
  const { t } = useTranslation();
  const [instCount, setInstCount] = useState(1);
  const ticketID = window.location.href.split("/")[4];
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const [isDiscountEdited, setIsDiscountEdited] = useState(false);
  const [manualDiscount, setManualDiscount] = useState(false);
  const [initialPremiumSet, setInitialPremiumSet] = useState({});
  const [manualInstallments, setManualInstallments] = useState({});
  const [installmentsDiff, setInstallmentsDiff] = useState({});
  const [hasInstallmentsDiff, setHasInstallmentsDiff] = useState(false);
  const [dateErrors, setDateErrors] = useState({});
  const now = new Date();
  const isProdApi = API_URL?.includes("cs-api.fidweb.net");
  const offerBaseCurrency = isProdApi ? getBaseCurrencyBySwitchDate(now) : "EUR";
  const offerDisplayOrder = isProdApi
    ? getDisplayCurrencyOrderBySwitchDate(now)
    : ["EUR", "BGN"];

  // Shows "≈ ..." in the secondary currency based on environment + switch date.
  const getBgnHint = (amount) => {
    const secondaryCurrency = offerDisplayOrder[1];
    const converted = convertCurrency(amount, offerBaseCurrency, secondaryCurrency);
    if (converted === null) return undefined;
    return `≈ ${formatMoney(converted)} ${getCurrencySymbol(secondaryCurrency)}`;
  };

  const {
    register,
    control,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    startDate: "",
    installmentsCount: 1,
    installmentOneDate: "",
    installmentTwoDate: null,
    installmentThreeDate: null,
    installmentFourDate: null,
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "offers",
  });

  const appendDiscount = (res) => {
    const type = res?.promoData?.policyType;
    if (res?.promoData?.discountCampaign?.discount) {
      const discount = res?.promoData?.discountCampaign?.discount;
      setValue(`offers.${0}.fullDiscount`, {
        type: type,
        discount: discount,
        percent: res?.promoData?.discountCampaign?.discountInPercent,
        byCompany: null,
      });
      setValue("oldDiscount", discount);
    }
    //general for all types
    else if (
      res?.promoData?.discountCampaign?.customDiscounts?.filter(
        (disc) => disc?.policyType === type
      )[0].discount
    ) {
      const discount =
        res?.promoData?.discountCampaign?.customDiscounts?.filter(
          (disc) => disc?.policyType === type
        )[0].discount;
      setValue(`offers.${0}.fullDiscount`, {
        type: type,
        discount: discount,
        percent: res?.promoData?.discountCampaign?.discountInPercent,
        byCompany: null,
      });
      setValue("oldDiscount", discount);
    }
    //general for all companies
    // different for every company
    else {
      setValue(`offers.${0}.fullDiscount`, {
        type: type,
        discount: null,
        byCompany: res?.promoData?.discountCampaign?.customDiscounts?.filter(
          (disc) => disc?.policyType === type
        )?.[0]?.customDiscountsPerInsuranceAgency,
        percent: res?.promoData?.discountCampaign?.discountInPercent,
      });
    }
  };

  useEffect(() => {
    listAgencies();
    getCurrentTicket({
      id: ticketID,
      onSuccess: (res) => {
        appendDiscount(res);
      },
    });
    setValue("installmentsCount", 1);
    append({
      insuranceCompanyName: "",
      insuranceCompanyId: "",
      insuranceSum: null,
      premium: null,
      originalPremium: null,
      installmentOneSum: null,
      installmentTwoSum: null,
      installmentThreeSum: null,
      installmentFourSum: null,
      documents: "",
      generalConditions: "",
      additionalInfo: "",
      liquidation: "",
      view: "",
      security: "",
      premiumInfo: [],
      fullDiscount: {
        discount: 0,
        percent: false,
        type: "",
        byCompany: null,
      },
    });
  }, []);

  const calculatePercentDiscount = (premium, discount) => {
    if (discount > 0 && premium) {
      const formula = premium - ((premium / 1.02) * discount) / 100;
      return calculateMonetary(formula);
    } else return premium;
  };

  // Calculate the total amount with or without discount
  const calculateTotalAmount = (offer) => {
    if (!offer) return 0;

    if (manualDiscount || currentTicket?.promoData) {
      const originalPremium = Number(offer?.originalPremium || 0);
      const discount = Number(offer?.fullDiscount?.discount || 0);

      if (discount <= 0) return originalPremium;

      if (offer?.fullDiscount?.percent) {
        return calculatePercentDiscount(originalPremium, discount);
      } else {
        return Math.max(0, originalPremium - discount);
      }
    } else {
      return Number(offer?.premium || 0);
    }
  };

  // Function to calculate discounted amount for an offer index
  const calculateDiscountedAmount = (offerIndex) => {
    const offer = watch(`offers.${offerIndex}`);
    const originalPremium = Number(offer?.originalPremium || 0);
    const discount = Number(offer?.fullDiscount?.discount || 0);

    if (discount <= 0 || !originalPremium) return originalPremium;

    // Always use percent discount
    return calculatePercentDiscount(originalPremium, discount);
  };

  // Calculate and display difference between premium and installments sum
  const calculateInstallmentsDiff = (offerIndex) => {
    const totalAmount =
      manualDiscount || currentTicket?.promoData
        ? calculateDiscountedAmount(offerIndex)
        : Number(watch(`offers.${offerIndex}.premium`));

    if (!totalAmount) return 0;

    let installmentsSum = 0;
    let hasAnyInstallment = false;
    for (let i = 0; i < instCount; i++) {
      const price = watch(`offers.${offerIndex}.installments.${i}.price`);
      if (price) hasAnyInstallment = true;
      installmentsSum += Number(price) || 0;
    }

    // Only calculate difference if both premium and at least one installment are set
    if (!hasAnyInstallment) return 0;

    const diff = Number((totalAmount - installmentsSum).toFixed(2));
    setInstallmentsDiff((prev) => ({ ...prev, [offerIndex]: diff }));

    // Update hasInstallmentsDiff without recursion
    setTimeout(() => {
      const anyDiffs = Object.values(installmentsDiff).some(
        (diff) => diff !== 0
      );
      setHasInstallmentsDiff(anyDiffs);
    }, 0);

    return diff;
  };

  // Update installments when premium or discount changes - only on initial entry
  const updateInstallmentsForOffer = (offerIndex, options = {}) => {
    const countOverride = options?.countOverride;
    const force = options?.force === true;
    const installmentsCountToUse = countOverride || instCount;
    const totalAmount =
      manualDiscount || currentTicket?.promoData
        ? calculateDiscountedAmount(offerIndex)
        : Number(watch(`offers.${offerIndex}.premium`));

    if (!totalAmount || !installmentsCountToUse) return;

    // If user already edited installments manually, don't overwrite unless forced
    if (manualInstallments?.[offerIndex] && !force) {
      calculateInstallmentsDiff(offerIndex);
      return;
    }

    const amountPerInstallment = Number(
      (totalAmount / installmentsCountToUse).toFixed(2)
    );

    let totalDistributed = 0;
    for (let i = 0; i < installmentsCountToUse; i++) {
      if (i === installmentsCountToUse - 1) {
        const lastInstallment = Number(
          (totalAmount - totalDistributed).toFixed(2)
        );
        setValue(
          `offers.${offerIndex}.installments.${i}.price`,
          lastInstallment
        );
      } else {
        setValue(
          `offers.${offerIndex}.installments.${i}.price`,
          amountPerInstallment
        );
        totalDistributed += amountPerInstallment;
      }

      // Set default date only if not already set
      if (!watch(`offers.${offerIndex}.installments.${i}.date`)) {
        const prevDate =
          i > 0
            ? watch(`offers.${offerIndex}.installments.${i - 1}.date`)
            : watch(`offers.${offerIndex}.startDate`);
        if (prevDate) {
          const nextDate = moment(prevDate).add(1, "month");
          setValue(`offers.${offerIndex}.installments.${i}.date`, nextDate._d);
        }
      }
    }
    setManualInstallments((prev) => ({ ...prev, [offerIndex]: false }));
    calculateInstallmentsDiff(offerIndex);
  };

  // Handle premium change
  const handlePremiumChange = (e, offerIndex) => {
    const value = Number(e.target.value);
    if (manualDiscount || currentTicket?.promoData) {
      setValue(`offers.${offerIndex}.originalPremium`, value);
    } else {
      setValue(`offers.${offerIndex}.premium`, value);
    }
    // No automatic calculation here, will be done on blur
  };

  // Handle premium blur - calculate installments when leaving the field
  const handlePremiumBlur = (offerIndex) => {
    updateInstallmentsForOffer(offerIndex);
    setInitialPremiumSet((prev) => ({ ...prev, [offerIndex]: true }));
  };

  const handleInstallmentsCountChange = (newCount) => {
    setValue("installmentsCount", newCount);
    setInstCount(newCount);

    // Switching count should re-distribute automatically (fresh start)
    setManualInstallments({});

    for (let i = 0; i < fields.length; i++) {
      const total = calculateTotalAmount(watch(`offers.${i}`));
      if (total) {
        updateInstallmentsForOffer(i, { force: true, countOverride: newCount });
        setInitialPremiumSet((prev) => ({ ...prev, [i]: true }));
      }
    }
  };

  // Handle discount change
  const handleDiscountChange = (e, offerIndex) => {
    setIsDiscountEdited(true);
    let val = e.target.value.replace(/^0+(?=\d)/, '');
    setValue(
      `offers.${offerIndex}.fullDiscount.discount`,
      Number(val)
    );
    setValue(`offers.${offerIndex}.fullDiscount.percent`, true); // Always set discount as percentage
    updateInstallmentsForOffer(offerIndex); // Recalculate installments when discount changes
  };

  const handleOfferWithoutDiscount = (e) => {
    // Ensure installments are calculated at least once before submit
    for (let i = 0; i < fields.length; i++) {
      const totalAmount = Number(watch(`offers.${i}.premium`));
      if (!totalAmount) continue;

      let hasAnyInstallment = false;
      for (let j = 0; j < instCount; j++) {
        const val = watch(`offers.${i}.installments.${j}.price`);
        if (val !== "" && val !== null && val !== undefined) {
          hasAnyInstallment = true;
          break;
        }
      }

      if (!hasAnyInstallment) {
        updateInstallmentsForOffer(i, { force: true });
        setInitialPremiumSet((prev) => ({ ...prev, [i]: true }));
      }
    }

    // Check all offers' installments
    for (let i = 0; i < fields.length; i++) {
      const diff = calculateInstallmentsDiff(i);
      if (diff !== 0) {
        toast.error(
          t("offers:offerNInstallmentsDiffer", {
            offer: i + 1,
            diff: Math.abs(diff),
            currency: getCurrencySymbol(offerBaseCurrency),
          })
        );
        return;
      }
    }
    const payload = {
      mainParams: {
        ticket: ticketID,
        startDate: moment(e.startDate).format("YYYY-MM-DD"),
        installmentsCount: e.installmentsCount,
        installmentOneDate: moment(e.installmentOneDate).format("YYYY-MM-DD"),
        installmentTwoDate: e.installmentTwoDate
          ? moment(e.installmentTwoDate).format("YYYY-MM-DD")
          : undefined,
        installmentThreeDate: e.installmentThreeDate
          ? moment(e.installmentThreeDate).format("YYYY-MM-DD")
          : undefined,
        installmentFourDate: e.installmentFourDate
          ? moment(e.installmentFourDate).format("YYYY-MM-DD")
          : undefined,
      },
      offers: fields.map((_, offerIndex) => {
        const offer = watch(`offers.${offerIndex}`) || {};
        const installmentOne = offer?.installments?.[0]?.price;
        const installmentTwo = offer?.installments?.[1]?.price;
        const installmentThree = offer?.installments?.[2]?.price;
        const installmentFour = offer?.installments?.[3]?.price;

        return {
          ...offer,
          documents: [offer.documents],
          generalConditions: [offer.generalConditions],
          installmentOneSum: Number(installmentOne || 0),
          installmentTwoSum:
            instCount >= 2 ? Number(installmentTwo || 0) : undefined,
          installmentThreeSum:
            instCount >= 3 ? Number(installmentThree || 0) : undefined,
          installmentFourSum:
            instCount === 4 ? Number(installmentFour || 0) : undefined,
          liquidation: offer?.liquidation,
          view: offer?.view,
          security: offer?.security,
          premiumInfo: offer?.premiumInfo.map((info) => info.value),
          premium: offer?.premium,
        };
      }),
      onSuccess: (res) => {
        toast.success(t("app:offerCreated"));
        navigate(-1);
      },
    };

    console.log("[Offer][create] payload (no discount)", {
      ticket: payload?.mainParams?.ticket,
      installmentsCount: payload?.mainParams?.installmentsCount,
      offersCount: payload?.offers?.length,
      firstOffer: payload?.offers?.[0] && {
        insuranceCompanyId: payload?.offers?.[0]?.insuranceCompanyId,
        insuranceSum: payload?.offers?.[0]?.insuranceSum,
        premium: payload?.offers?.[0]?.premium,
        originalPremium: payload?.offers?.[0]?.originalPremium,
        installmentOneSum: payload?.offers?.[0]?.installmentOneSum,
        installmentTwoSum: payload?.offers?.[0]?.installmentTwoSum,
        installmentThreeSum: payload?.offers?.[0]?.installmentThreeSum,
        installmentFourSum: payload?.offers?.[0]?.installmentFourSum,
      },
    });
    createOffer(payload);
  };

  const handleOfferWithDiscount = (e) => {
    // Ensure installments are calculated at least once before submit
    for (let i = 0; i < fields.length; i++) {
      const totalAmount = calculateDiscountedAmount(i);
      if (!totalAmount) continue;

      let hasAnyInstallment = false;
      for (let j = 0; j < instCount; j++) {
        const val = watch(`offers.${i}.installments.${j}.price`);
        if (val !== "" && val !== null && val !== undefined) {
          hasAnyInstallment = true;
          break;
        }
      }

      if (!hasAnyInstallment) {
        updateInstallmentsForOffer(i, { force: true });
        setInitialPremiumSet((prev) => ({ ...prev, [i]: true }));
      }
    }

    // Check all offers' installments
    for (let i = 0; i < fields.length; i++) {
      const diff = calculateInstallmentsDiff(i);
      if (diff !== 0) {
        toast.error(
          t("offers:offerNInstallmentsDiffer", {
            offer: i + 1,
            diff: Math.abs(diff),
            currency: getCurrencySymbol(offerBaseCurrency),
          })
        );
        return;
      }
    }

    const payload = {
      mainParams: {
        ticket: ticketID,
        startDate: moment(e.startDate).format("YYYY-MM-DD"),
        installmentsCount: e.installmentsCount,
        installmentOneDate: moment(e.installmentOneDate).format("YYYY-MM-DD"),
        installmentTwoDate: e.installmentTwoDate
          ? moment(e.installmentTwoDate).format("YYYY-MM-DD")
          : undefined,
        installmentThreeDate: e.installmentThreeDate
          ? moment(e.installmentThreeDate).format("YYYY-MM-DD")
          : undefined,
        installmentFourDate: e.installmentFourDate
          ? moment(e.installmentFourDate).format("YYYY-MM-DD")
          : undefined,
      },
      offers: fields.map((_, offerIndex) => {
        const offer = watch(`offers.${offerIndex}`) || {};
        // Винаги изчисляваме като процентна отстъпка
        const discountedAmount = calculatePercentDiscount(
          offer?.originalPremium,
          offer?.fullDiscount.discount
        );

        return {
          ...offer,
          documents: [offer.documents],
          generalConditions: [offer.generalConditions],
          installmentOneSum: Number(offer?.installments?.[0]?.price),
          installmentTwoSum:
            instCount >= 2 ? Number(offer?.installments?.[1]?.price) : undefined,
          installmentThreeSum:
            instCount >= 3 ? Number(offer?.installments?.[2]?.price) : undefined,
          installmentFourSum:
            instCount === 4 ? Number(offer?.installments?.[3]?.price) : undefined,
          liquidation: offer?.liquidation,
          view: offer?.view,
          security: offer?.security,
          premiumInfo: offer?.premiumInfo?.map((info) => info.value),
          premium: offer?.originalPremium
            ? Number(discountedAmount)
            : offer?.premium,
          ...(offer?.fullDiscount.discount &&
            offer?.fullDiscount?.discount > 0 && {
              discountInfo: `-${offer?.fullDiscount.discount}%`,
            }),
        };
      }),
      onSuccess: (res) => {
        toast.success(t("app:offerCreated"));
        navigate(-1);
      },
    };

    console.log("[Offer][create] payload (with discount)", {
      ticket: payload?.mainParams?.ticket,
      installmentsCount: payload?.mainParams?.installmentsCount,
      offersCount: payload?.offers?.length,
      firstOffer: payload?.offers?.[0] && {
        insuranceCompanyId: payload?.offers?.[0]?.insuranceCompanyId,
        insuranceSum: payload?.offers?.[0]?.insuranceSum,
        premium: payload?.offers?.[0]?.premium,
        originalPremium: payload?.offers?.[0]?.originalPremium,
        discountInfo: payload?.offers?.[0]?.discountInfo,
      },
    });
    createOffer(payload);
  };

  // Validate installment date
  const validateInstallmentDate = (index, newDate) => {
    const errors = { ...dateErrors };
    let isValid = true;

    const startDate = watch("startDate");
    if (startDate && moment(newDate).isBefore(moment(startDate))) {
      errors[index] = t("offers:dateBeforePolicyStart");
      isValid = false;
    } else if (index > 0) {
      const prevDate = watch(`offers.${0}.installments.${index - 1}.date`);
      if (prevDate && moment(newDate).isBefore(moment(prevDate))) {
        errors[index] = t("offers:dateBeforePrevious");
        isValid = false;
      }
    } else {
      delete errors[index];
    }

    setDateErrors(errors);
    return isValid;
  };

  const clearDateError = (index) => {
    if (dateErrors[index]) {
      const updatedErrors = { ...dateErrors };
      delete updatedErrors[index];
      setDateErrors(updatedErrors);
    }
  };

  return (
    <div className={styles["amarant-container"]}>
      <div className={styles["upper-info-container"]}>
        <div
          style={{
            display: "flex",
            width: "40%",
            alignItems: "center",
            marginLeft: "1%",
          }}
        >
          <h2 className={styles["title"]}>{t("offers:createOffers")}</h2>
          {currentTicket?.promoData && (
            <div
              className={styles["info-icon"]}
              onClick={() => setOpenModal(true)}
            />
          )}
        </div>
        <Inputs.Button
          text={t("save")}
          className="green"
          style={{ marginRight: "1%", width: "130px" }}
          onClick={handleSubmit((e) => {
            if (!currentTicket?.promoData && !manualDiscount)
              handleOfferWithoutDiscount(e);
            else handleOfferWithDiscount(e);
          })}
        />
      </div>
      <div className={styles["middle-info-container"]}>
        <h2 className={styles["title"]}>{t("offers:mainParams")}</h2>
        <div className={styles["main-parameters-container"]}>
          <Controller
            control={control}
            name={"startDate"}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Inputs.DatePicker
                label={t("offers:startDate")}
                compulsory
                custom
                style={{ width: "12%", height: "100%" }}
                value={value}
                onChange={(e) => {
                  if (e === "") {
                    setValue("startDate", "");
                  } else if (e instanceof Date) {
                    setValue("startDate", e);
                  } else {
                    console.log("Неочакван формат на дата:", e);
                  }
                }}
                className={error && "failed"}
              />
            )}
            rules={{ required: true }}
          />
          <Controller
            control={control}
            name={"installmentsCount"}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <div style={{ margin: "0% 3%" }}>
                <label>{t("offers:installmentCount")}</label>
                <div style={{ display: "flex" }}>
                  <Inputs.Button
                    text={1}
                    selected={value === 1}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      handleInstallmentsCountChange(1);
                    }}
                  />
                  <Inputs.Button
                    text={2}
                    selected={value === 2}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      handleInstallmentsCountChange(2);
                    }}
                  />
                  <Inputs.Button
                    text={3}
                    selected={value === 3}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      handleInstallmentsCountChange(3);
                    }}
                  />
                  <Inputs.Button
                    text={4}
                    selected={value === 4}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      handleInstallmentsCountChange(4);
                    }}
                  />
                </div>
              </div>
            )}
            rules={{ required: true }}
          />
          {Array(instCount)
            .fill("")
            .map((el, i) => {
              return (
                <Controller
                  control={control}
                  key={i}
                  name={instalPairs[i].key}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <div
                      style={{
                        position: "relative",
                        width: "12%",
                        margin: "0% 2%",
                      }}
                    >
                      <Inputs.DatePicker
                        label={t(instalPairs[i].labelKey, { n: instalPairs[i].n })}
                        compulsory
                        custom
                        style={{ width: "100%", height: "100%" }}
                        value={value}
                        minDate={
                          i > 0
                            ? watch(instalPairs[i - 1].key)
                            : watch("startDate")
                        }
                        onChange={(e) => {
                          if (e === "") {
                            setValue(instalPairs[i].key, "");
                            clearDateError(i);
                          } else if (e instanceof Date) {
                            setValue(instalPairs[i].key, e);
                            validateInstallmentDate(i, e);
                          } else {
                            console.log("Неочакван формат на дата:", e);
                          }
                        }}
                        className={error || dateErrors[i] ? "failed" : ""}
                      />
                      {dateErrors[i] && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.7rem",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            top: "100%",
                          }}
                        >
                          {dateErrors[i]}
                        </div>
                      )}
                    </div>
                  )}
                  rules={{ required: true }}
                />
              );
            })}
          <div className="input-container" style={{ width: "5%" }}>
            <label
              style={{
                display: "flex",
                width: "100%",
                fontSize: "0.8rem",
                marginBottom: "5px",
              }}
            >
              {t("offers:discount")}
            </label>
            <p
              style={{
                marginTop: "10px",
                color: currentTicket?.promoData && "#01D088",
              }}
            >
              {currentTicket?.promoData ? t("yes") : t("no")}
            </p>
          </div>
        </div>
      </div>
      {fields?.map((offer, i) => {
        return (
          <div className={styles["lower-info-container"]} key={i}>
            <div
              style={{ display: "flex", width: "100%", alignItems: "center" }}
            >
              <h2 className={styles["title"]}>{t("offers:offerN", { n: i + 1 })}</h2>
              {fields?.length > 1 && (
                <div
                  className={styles["delete-icon"]}
                  onClick={() => remove(i)}
                />
              )}
            </div>
            <div>
              <div className={styles["main-parameters-container"]}>
                <Controller
                  control={control}
                  name={`offers.${i}.insuranceCompanyName`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <Inputs.Dropdown
                      label={t("offers:insuranceCompany")}
                      optionsArray={agencies?.map((agency) => ({
                        label: agency?.name,
                        value: agency?._id,
                      }))}
                      key={offer.id}
                      compulsory
                      customStyles={customStyles}
                      style={{
                        width: "200px",
                        marginRight: "20px",
                      }}
                      single
                      value={value}
                      className={error && "failed"}
                      onChange={(e) => {
                        setValue(`offers.${i}.insuranceCompanyName`, e.label);
                        setValue(`offers.${i}.insuranceCompanyId`, e.value);
                        if (watch()?.offers?.[i]?.fullDiscount?.byCompany) {
                          const discount = watch()?.offers?.[
                            i
                          ]?.fullDiscount?.byCompany?.filter(
                            (comp) => comp?.insuranceAgency === e.value
                          )?.length
                            ? watch()?.offers?.[
                                i
                              ]?.fullDiscount.byCompany?.filter(
                                (comp) => comp?.insuranceAgency === e.value
                              )?.[0]?.discount
                            : 0;
                          setValue(
                            `offers.${i}.fullDiscount.discount`,
                            discount
                          );
                          setValue("oldDiscount", discount);
                        }
                      }}
                    />
                  )}
                  rules={{ required: true }}
                />

                <div style={{ width: "200px", marginRight: "20px" }}>
                  <Inputs.TextInput
                    label={t("offers:insuranceSum")}
                    suffix={getCurrencySymbol(offerBaseCurrency)}
                    style={{ width: "100%" }}
                    className={errors.offers?.[i]?.insuranceSum ? "failed" : ""}
                    {...register(`offers.${i}.insuranceSum`)}
                  />
                  {getBgnHint(watch(`offers.${i}.insuranceSum`)) && (
                    <div className={styles["currency-hint"]}>
                      {getBgnHint(watch(`offers.${i}.insuranceSum`))}
                    </div>
                  )}
                </div>

                {!currentTicket?.promoData && !manualDiscount ? (
                  <Controller
                    control={control}
                    name={`offers.${i}.premium`}
                    render={({
                      field: { value, onChange },
                      fieldState: { error },
                    }) => (
                      <div style={{ width: "200px", marginRight: "20px" }}>
                        <Inputs.TextInput
                          label={t("offers:premium")}
                          compulsory
                          suffix={getCurrencySymbol(offerBaseCurrency)}
                          type="number"
                          style={{ width: "100%" }}
                          className={
                            errors.offers?.[i]?.premium ? "failed" : ""
                          }
                          onChange={(e) => handlePremiumChange(e, i)}
                          onBlur={() => handlePremiumBlur(i)}
                        />
                        {getBgnHint(watch(`offers.${i}.premium`)) && (
                          <div className={styles["currency-hint"]}>
                            {getBgnHint(watch(`offers.${i}.premium`))}
                          </div>
                        )}
                      </div>
                    )}
                    rules={{ required: true }}
                  />
                ) : (
                  <Controller
                    control={control}
                    name={`offers.${i}.originalPremium`}
                    render={({
                      field: { value, onChange },
                      fieldState: { error },
                    }) => (
                      <>
                        <div style={{ width: "200px", marginRight: "20px" }}>
                          <Inputs.TextInput
                            label={t("offers:premium")}
                            compulsory
                            suffix={getCurrencySymbol(offerBaseCurrency)}
                            type="number"
                            style={{ width: "100%" }}
                            className={
                              errors.offers?.[i]?.originalPremium
                                ? "failed"
                                : ""
                            }
                            onChange={(e) => handlePremiumChange(e, i)}
                            onBlur={() => handlePremiumBlur(i)}
                          />
                          {getBgnHint(watch(`offers.${i}.originalPremium`)) && (
                            <div className={styles["currency-hint"]}>
                              {getBgnHint(watch(`offers.${i}.originalPremium`))}
                            </div>
                          )}
                        </div>

                        <div style={{ width: "200px", marginRight: "20px" }}>
                          <Inputs.TextInput
                            label={t("offers:premiumWithDiscount")}
                            suffix={getCurrencySymbol(offerBaseCurrency)}
                            value={calculateDiscountedAmount(i)}
                            disabled
                            style={{ width: "100%" }}
                          />
                          {getBgnHint(calculateDiscountedAmount(i)) && (
                            <div className={styles["currency-hint"]}>
                              {getBgnHint(calculateDiscountedAmount(i))}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    rules={{ required: true }}
                  />
                )}

                {Array(instCount)
                  .fill("")
                  .map((el, j) => (
                    <div
                      key={j}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginRight: "20px",
                        height: "65px",
                        marginTop: "5px",
                        position: "relative",
                        width: "200px",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <label
                          style={{
                            display: "block",
                            fontSize: "0.8rem",
                            marginBottom: "3px",
                            whiteSpace: "nowrap",
                            height: "16px",
                          }}
                        >
                          {t("offers:installmentNAmount", { n: j + 1 })}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Inputs.TextInput
                          compulsory={false}
                          suffix={getCurrencySymbol(offerBaseCurrency)}
                          style={{
                            width: "100%",
                            height: "40px",
                            borderColor:
                              installmentsDiff[i] !== 0 && initialPremiumSet[i]
                                ? "#ff9800"
                                : undefined,
                          }}
                          disabled={false}
                          className={
                            errors?.offers?.[i]?.installments?.[j]?.price
                              ? "failed"
                              : ""
                          }
                          type="text"
                          pattern="^\\d+(\\.\\d{0,2})?$"
                          value={watch(`offers.${i}.installments.${j}.price`) ?? ""}
                          onChange={(e) => {
                            let val = e.target.value.replace(',', '.');
                            setValue(`offers.${i}.installments.${j}.price`, val);
                            setManualInstallments((prev) => ({
                              ...prev,
                              [i]: true,
                            }));
                            setInitialPremiumSet((prev) => ({
                              ...prev,
                              [i]: true,
                            }));
                            calculateInstallmentsDiff(i);
                          }}
                          {...register(`offers.${i}.installments.${j}.price`, {
                            required: true,
                            pattern: { value: /^\d+(\.\d{0,2})?$/, message: t("offers:invalidAmount") },
                          })}
                        />
                        {getBgnHint(
                          watch(`offers.${i}.installments.${j}.price`)
                        ) && (
                          <div className={styles["currency-hint"]}>
                            {getBgnHint(
                              watch(`offers.${i}.installments.${j}.price`)
                            )}
                          </div>
                        )}
                      </div>
                      {j === instCount - 1 &&
                        installmentsDiff[i] !== 0 &&
                        initialPremiumSet[i] && (
                          <div
                            style={{
                              color: "#ff9800",
                              fontSize: "0.8rem",
                              marginLeft: "10px",
                              whiteSpace: "nowrap",
                              position: "absolute",
                              left: "210px",
                              top: "28px",
                              zIndex: 5,
                            }}
                          >
                            {/* Removing warning here, will be shown below discount switch */}
                          </div>
                        )}
                    </div>
                  ))}

                {(currentTicket?.promoData || manualDiscount) && (
                  <>
                    <Inputs.TextInput
                      label={t("offers:discount")}
                      compulsory
                      suffix={"%"}
                      type="number"
                      style={{ width: "200px", marginRight: "20px" }}
                      value={watch()?.offers?.[i]?.fullDiscount?.discount ?? ""}
                      onFocus={() => {
                        setValue(`offers.${i}.fullDiscount.discount`, "");
                      }}
                      onChange={(e) => handleDiscountChange(e, i)}
                    />

                    {isDiscountEdited && (
                      <Inputs.TextInput
                        label={t("offers:discountDescription")}
                        compulsory
                        style={{ width: "350px", marginRight: "20px" }}
                        {...register(`offers.${i}.discountTextOverwrite`)}
                      />
                    )}
                  </>
                )}

                {!currentTicket?.promoData && (
                  <div
                    className="input-container"
                    style={{
                      width: "200px",
                      marginRight: "20px",
                      height: "65px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        width: "100%",
                        fontSize: "0.8rem",
                        marginBottom: "5px",
                      }}
                    >
                      {t("offers:addDiscountTitle")}
                    </label>
                    <Switch
                      checked={manualDiscount}
                      onChange={() => {
                        setManualDiscount(!manualDiscount);
                        if (!manualDiscount) {
                          // When adding discount, copy premium to originalPremium
                          fields.forEach((offer, idx) => {
                            const premiumValue = watch(`offers.${idx}.premium`);
                            if (premiumValue) {
                              setValue(
                                `offers.${idx}.originalPremium`,
                                Number(premiumValue)
                              );
                              setValue(
                                `offers.${idx}.fullDiscount.discount`,
                                0
                              );
                              setValue(
                                `offers.${idx}.fullDiscount.percent`,
                                true
                              );
                            }
                          });
                        } else {
                          // When removing discount, copy originalPremium back to premium
                          fields.forEach((offer, idx) => {
                            const originalPremium = watch(
                              `offers.${idx}.originalPremium`
                            );
                            if (originalPremium) {
                              setValue(
                                `offers.${idx}.premium`,
                                Number(originalPremium)
                              );
                            }
                          });
                        }
                      }}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#0476FB",
                          "&:hover": {
                            backgroundColor: "rgba(4, 118, 251, 0.08)",
                          },
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#0476FB",
                          },
                      }}
                    />
                    {installmentsDiff[i] !== 0 && initialPremiumSet[i] && (
                      <div
                        style={{
                          color: "#ff9800",
                          fontSize: "0.8rem",
                          marginTop: "5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {installmentsDiff[i] > 0
                          ? t("offers:leftToAllocateCur", {
                              amount: installmentsDiff[i],
                              currency: getCurrencySymbol(offerBaseCurrency),
                            })
                          : t("offers:exceedsPremiumCur", {
                              amount: Math.abs(installmentsDiff[i]),
                              currency: getCurrencySymbol(offerBaseCurrency),
                            })}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className={styles["main-parameters-container-files"]}>
                <Controller
                  control={control}
                  name={`offers.${i}.documents`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <Inputs.ImageInput
                      label={t("offers:infoDocument")}
                      compulsory
                      style={{ width: "25%", margin: "10px 0px" }}
                      value={value}
                      specialDir={true}
                      info={{
                        keyword: "offer",
                        id: ticketID,
                        date: moment().format("DD.MM.YYYY"),
                      }}
                      key={"documents"}
                      onChange={(e) => setValue(`offers.${i}.documents`, e)}
                      setValue={setValue}
                      className={error && "failed"}
                    />
                  )}
                  rules={{ required: true }}
                />
                <Controller
                  control={control}
                  name={`offers.${i}.generalConditions`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <Inputs.ImageInput
                      label={t("offers:generalTerms")}
                      compulsory
                      style={{ width: "25%", margin: "10px 0px" }}
                      value={value}
                      specialDir={true}
                      info={{
                        keyword: "offer",
                        id: ticketID,
                        date: moment().format("DD.MM.YYYY"),
                      }}
                      onChange={(e) =>
                        setValue(`offers.${i}.generalConditions`, e)
                      }
                      setValue={setValue}
                      className={error && "failed"}
                    />
                  )}
                  rules={{ required: true }}
                />
              </div>
              <div className={styles["main-parameters-container"]}>
                <Controller
                  control={control}
                  name={`offers.${i}.liquidation`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <Inputs.Dropdown
                      label={t("offers:liquidationType")}
                      optionsArray={liquidationOptions?.map((liq) => {
                        return {
                          label: liq,
                          value: liq,
                        };
                      })}
                      customStyles={customStyles}
                      style={{ width: "23%", height: "100%" }}
                      single
                      value={value}
                      className={error && "failed"}
                      onChange={(e) => {
                        setValue(`offers.${i}.liquidation`, e.value);
                      }}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name={`offers.${i}.view`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <Inputs.Dropdown
                      label={t("offers:inspectionRequired")}
                      optionsArray={viewOptions?.map((view) => {
                        return {
                          label: view,
                          value: view,
                        };
                      })}
                      customStyles={customStyles}
                      style={{ width: "23%", height: "100%" }}
                      single
                      value={value}
                      onChange={(e) => {
                        setValue(`offers.${i}.view`, e.value);
                      }}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name={`offers.${i}.security`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <Inputs.Dropdown
                      label={t("offers:additionalSecurity")}
                      optionsArray={additionalSecurityOptions?.map((opt) => {
                        return {
                          label: opt,
                          value: opt,
                        };
                      })}
                      customStyles={customStyles}
                      style={{ width: "23%", height: "100%" }}
                      single
                      value={value}
                      onChange={(e) => {
                        setValue(`offers.${i}.security`, e.value);
                      }}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name={`offers.${i}.premiumInfo`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <Inputs.Dropdown
                      label={t("offers:premium")}
                      optionsArray={premiumInfoOptions?.map((opt) => {
                        return {
                          label: opt,
                          value: opt,
                        };
                      })}
                      customStyles={customStylesHigher}
                      style={{ width: "23%", height: "100%" }}
                      value={value}
                      onChange={(e) => {
                        setValue(`offers.${i}.premiumInfo`, e);
                      }}
                    />
                  )}
                />
              </div>
              <Inputs.TextInput
                label={t("offers:additionalOfferInfo")}
                compulsory
                style={{ width: "100%", margin: "1% 0%" }}
                className={errors.offers?.[i]?.additionalInfo ? "failed" : ""}
                {...register(`offers.${i}.additionalInfo`, {
                  required: true,
                })}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "right",
                  margin: "2% 0%",
                }}
              >
                {fields?.length - 1 === i && (
                  <Inputs.Button
                    text={t("offers:addNew")}
                    className="dotted"
                    onClick={() => {
                      append({
                        insuranceCompanyName: "",
                        insuranceCompanyId: "",
                        insuranceSum: null,
                        premium: null,
                        installmentOneSum: null,
                        installmentTwoSum: null,
                        installmentThreeSum: null,
                        installmentFourSum: null,
                        documents: "",
                        generalConditions: "",
                        additionalInfo: "",
                        fullDiscount: {
                          ...watch()?.offers?.[0]?.fullDiscount,
                          // discount: 0,
                        },
                      });
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      })}

      <ModalComponent
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
        children={
          <DiscountInfoModal
            discount={currentTicket?.promoData}
            type={watch()?.offers?.[0]?.fullDiscount?.type}
            handleClose={() => {
              setOpenModal(false);
            }}
          />
        }
      />

      {hasInstallmentsDiff && (
        <div
          style={{
            color: "red",
            fontSize: "0.8rem",
            marginTop: "5px",
            width: "100%",
            display: "block",
          }}
        >
          {t("offers:installmentsWarning")}
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  agencies: state.offer.agencies,
  currentTicket: state.tickets.currentTicket,
});
const mapDispatchToProps = (dispatch) => ({
  listAgencies: (payload) => dispatch(listAgencies(payload)),
  createOffer: (payload) => dispatch(createOffer(payload)),
  getCurrentTicket: (payload) => dispatch(getCurrentTicket(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CreateOffer);
